export default __webpack_public_path__ + "static/media/placeholdercar2.355b4022.png";